import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router) {

    }
    canActivate(): boolean {
        if (this.authService.isUserLoggedIn()) {
            return true;
        } else {
            this.router.navigate(['auth/login']);
            return false;
        }
    }
}
